import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import Loading from "../../components/loading";
import store from "../../reducers/createReducers";
import DataActions from "../../actions/data-actions";

const VipFaq = () => {

    const {t} = useTranslation()

    const {activeLanguage} = useSelector(state => state.globalReducer)
    const {faqR} = useSelector(state => state.dataReducer)

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [activeItem, setActiveItem] = useState({})


    useEffect(() => {
        if (data?.length >= 1)
            setActiveItem(data[0])
    }, [data])

    useEffect(() => {
        if (!loading && (!faqR || !faqR[activeLanguage?.key])) {

            associateServices.getFaqs({
                language: activeLanguage?.key
            }).then(res => {

                store.dispatch(DataActions.setFaqs({
                    data: res?.data,
                    type: activeLanguage?.key
                }))

                setLoading(false)
            })
        }

    }, [faqR, loading, activeLanguage?.key])


    useEffect(() => {
        try {
            setData(faqR[activeLanguage?.key] || [])
        } catch (e) {

        }
    }, [faqR, activeLanguage?.key])


    if (data?.length <= 0 && !loading)
        return null;

    return (
        <div className="section">
            <div className="container">
                {
                    loading ? <Loading/> :
                        <div className="row">
                            <div className="col-12">
                                <h2 className="section__title section__title--center">
                                    {t('faq.title')}
                                </h2>
                                <p className="section__text section__text--center">

                                    {t('faq.description')}

                                </p>
                            </div>
                            <div className="col-12">
                                <div className="tabs-nav-wrap">
                                    <ul className="nav nav-tabs tabs-nav" id="tabs-nav" role="tablist">
                                        {
                                            data?.map((item, oo) => (
                                                <li
                                                    key={oo}
                                                    className="nav-item" role="presentation">
                                                    <button
                                                        id={`${item.id}-tab`}
                                                        className={`tabs-nav__btn ${item.id === activeItem.id ? 'active' : ''}`}
                                                        onClick={e => setActiveItem(item)}
                                                        type="button"
                                                    >
                                                        {item?.name}
                                                    </button>
                                                </li>
                                            ))
                                        }

                                    </ul>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="tab-content">


                                    <div
                                        className="tab-pane fade show active row d-flex justify-content-around"
                                        id="tab-1"
                                        role="tabpanel"
                                        aria-labelledby="1-tab"
                                        tabIndex={0}
                                    >

                                        {
                                            activeItem?.faqs?.map((faq, iii) => (
                                                <div className="accordion col-xxl-5" key={`accordion${iii}`}>
                                                    <div className="row">
                                                        <div className="accordion__card ">
                                                            <button
                                                                className="collapsed"
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapse${iii}`}
                                                                aria-expanded="false"
                                                                aria-controls={`collapse${iii}`}
                                                            >
                                                                {faq.question}
                                                                <span>
                                                                  <svg
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                      viewBox="0 0 24 24"
                                                                  >
                                                                    <path d="M19,11H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2Z"/>
                                                                  </svg>
                                                                  <svg
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                      viewBox="0 0 24 24"
                                                                  >
                                                                    <path d="M19,11H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2Z"/>
                                                                  </svg>
                                                                </span>
                                                            </button>
                                                            <div
                                                                id={`collapse${iii}`}
                                                                className="collapse"
                                                                data-bs-parent={`#accordion${iii}`}
                                                            >
                                                                <div dangerouslySetInnerHTML={{__html: faq.answer}}/>
                                                                {/*<p>*/}
                                                                {/*    {faq.answer}*/}
                                                                {/*</p>*/}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }


                                    </div>

                                </div>
                            </div>
                        </div>
                }
            </div>
        </div>
    )

}

export default VipFaq
